import React, { useState } from 'react';
import moment from 'moment';

// Types
import { WpDayPickerTypes } from './types';
import { Variant } from '../button';

// Components
import { WpButton } from '../button';
import WpDayPicker from './WpDayPicker';
import { WpPopover, WpPopoverToggle, WpPopoverContent, Placement } from '../popover';
import WpIcon from '../icon/WpIcon';

export interface WpDayPickerDropdownProps extends WpDayPickerTypes {
  placement?: Placement;
  btnVariant?: Variant;
  placeholder?: string;
  onOpen?: Function;
  components?: {
    inner?: Function;
  };
  qaTest?: string;
}

const WpDayPickerDropdown = ({
  placement = 'bottom-start',
  onOpen,
  selected,
  onSelect,
  onMonthChange,
  mode,
  disabledDays,
  modifiers,
  toDate,
  modifiersClassNames,
  placeholder = 'Select date',
  btnVariant = 'secondary',
  components,
  qaTest,
}: WpDayPickerDropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const label = selected ? moment(selected).format('dddd, MMM Do YYYY') : placeholder;

  const handleOpen = value => {
    if (value === true && onOpen) onOpen();
    setIsOpen(value);
  };

  const handleOnSelect = value => {
    setIsOpen(false);
    onSelect && onSelect(value);
  };

  const CustomInner = () => {
    const CustomInner = components?.inner;
    return (
      <div>
        <CustomInner />
      </div>
    );
  };

  const InnerMarkup = components?.inner ? (
    CustomInner()
  ) : (
    <WpButton variant={btnVariant}>
      <WpIcon name="calendar-alt" />
      {label}
      <WpIcon name="angle-down" />
    </WpButton>
  );

  const baseClassName = 'WpDayPickerDropdown';
  return (
    <div className={baseClassName}>
      <WpPopover open={isOpen} onOpenChange={handleOpen} placement={placement} showArrow={false}>
        <WpPopoverToggle qaTest={qaTest ? `${qaTest}-toggle` : ''}>{InnerMarkup}</WpPopoverToggle>
        <WpPopoverContent>
          <WpDayPicker
            mode={mode}
            onSelect={handleOnSelect}
            selected={selected}
            onMonthChange={onMonthChange}
            disabledDays={disabledDays}
            modifiers={modifiers}
            modifiersClassNames={modifiersClassNames}
            toDate={toDate}
          />
        </WpPopoverContent>
      </WpPopover>
    </div>
  );
};

export default WpDayPickerDropdown;
